// Pull the edited values for `fields` out of a form's `state` into a payload
// for the update mutation. A field the user blanked out is sent as an explicit
// null (rather than omitted) when `original` had a value, so the mutation
// actually removes it. Uses null/undefined checks rather than truthiness so a
// real numeric `0` (e.g. a counter at zero) is kept, and a `0` the user
// cleared is really cleared.
//
// Lives here (not in EditForm.jsx, which re-exports it) so non-component code
// -- useAutosave in particular -- can build payloads without importing any
// React component machinery.
export function buildEditedFields(fields, state, original) {
  const editedItem = {};

  function copyField(key) {
    const value = state ? state[key] : null;
    if (value != null) {
      editedItem[key] = value;
    } else if (original && original[key] !== null && original[key] !== undefined) {
      editedItem[key] = null;
    }
  }

  for (const field of fields) {
    copyField(field.key);
    // Interval fields span two underlying keys (days + months); carry the
    // second one too so switching the unit persists.
    if (field.type === 'interval' && field.monthsKey) {
      copyField(field.monthsKey);
    }
    // An `idKey` field spans two keys the same way: the typed display value
    // and the id it binds to -- a trip field's tripGroupId (TripIdentity.mjs),
    // a captain field's captainUserId. Carrying it here is what makes the
    // binding ride every payload without each save handler knowing it exists
    // -- and `copyField` sends a cleared id as an explicit null, which is
    // exactly what "typing a new name takes this leg out of the trip" needs
    // to persist. Keyed on `idKey` alone, not the field type: rendering stays
    // type-specific (only 'trip' gets the typeahead), but the two-key save
    // contract is the same for every binding.
    if (field.idKey) {
      copyField(field.idKey);
    }
  }

  return editedItem;
}

export default buildEditedFields;
